<!-- src/components/common/SideBar.vue -->
<template>
  <aside class="app-sidebar">
    <!-- <div class="app-sidebar__user" v-if="currentUser">
      <img class="app-sidebar__user-avatar"
        :src="currentUser.profile_image ? `http://localhost:8000/storage/${currentUser.profile_image}` : 'https://randomuser.me/api/portraits/men/1.jpg'"
        alt="User Image">
      <div>
        <p class="app-sidebar__user-name">{{ currentUser.name }}</p>
        <p class="app-sidebar__user-designation">{{ currentUser.role }}</p>
      </div>
    </div> -->
    <!-- <pre>{{currentUser.account?.image}}</pre> -->
    <div class="app-sidebar__user text-center" v-if="currentUser">
      <img
        v-if="currentUser"
        :src="`data:image/png;base64,${currentUser.account?.image}`"
        alt="User Image"
        width="100"
        class="mb-3"
      />
      <img
        v-else
        src="@/assets/user.png"
        alt="User Image"
        width="120"
        class="mb-3"
      />
      <div>
        <p class="app-sidebar__user-name">{{ currentUser?.name }}</p>
        <p class="app-sidebar__user-designation">
          {{ currentUser.account?.job_position }}
        </p>
        <p class="app-sidebar__user-designation">
          {{ currentUser.department?.name }}
        </p>
        <!-- <p class="app-sidebar__user-designation">{{ currentUser || 'No Position' }}</p> -->
        <!-- <p class="app-sidebar__user-designation">
          <span v-if="account.department">{{ currentUser.department?.name }}</span>
        </p> -->
      </div>
    </div>

    <div v-else>Loading user info...</div>
    <ul class="app-menu">
      <li>
        <router-link class="app-menu__item" to="/">
          <i class="app-menu__icon bi bi-speedometer"></i>
          <span class="app-menu__label">หน้าหลัก</span>
        </router-link>
      </li>

      <li>
        <router-link class="app-menu__item" to="/screening">
          <i class="app-menu__icon bi bi-clipboard-pulse"></i>
          <span class="app-menu__label">APACHE II Screening</span>
        </router-link>
      </li>
      <li>
        <router-link class="app-menu__item" to="/patient-list">
          <i class="app-menu__icon bi bi-list-ol"></i>
          <span class="app-menu__label">รายชื่อผู้ป่วย</span>
        </router-link>
      </li>

      <!-- Add a link for User Management -->
      <div
        v-if="currentUser && ['admin', 'owner'].includes(currentUser.role)"
      ></div>

      <!-- <div> -->
      <!-- <li>
          <router-link class="app-menu__item" to="/users">
            <i class="app-menu__icon bi bi-people"></i>
            <span class="app-menu__label">User Management</span>
          </router-link>
        </li> -->

      <!-- <li>
          <router-link class="app-menu__item" to="/roles">
            <i class="app-menu__icon bi bi-person-badge"></i>
            <span class="app-menu__label">Role Management</span>
          </router-link>
        </li>
    -->

      <!-- Dynamically rendered menu items using v-for -->
      <!-- <li v-for="(item, index) in menuItems" :key="index"
        :class="{ 'treeview': item.isTreeview, 'is-expanded': item.isExpanded }">

        <template v-if="item.isTreeview">
          <a class="app-menu__item" href="#" @click.prevent="toggleTreeview(index)">
            <i :class="['app-menu__icon', item.icon]"></i>
            <span class="app-menu__label">{{ item.label }}</span>
            <i class="treeview-indicator bi bi-chevron-right"></i>
          </a>
          <ul class="treeview-menu" v-if="item.isExpanded">
            <li v-for="(subItem, subIndex) in item.submenu" :key="subIndex">
              <template v-if="subItem.link.startsWith('http')">
                <a class="treeview-item" :href="subItem.link" target="_blank" rel="noopener">
                  <i :class="['icon', subItem.icon]"></i> {{ subItem.label }}
                </a>
              </template>
<template v-else>
                <router-link class="treeview-item" :to="subItem.link">
                  <i :class="['icon', subItem.icon]"></i> {{ subItem.label }}
                </router-link>
              </template>
</li>
</ul>
</template>
<template v-else>
          <router-link class="app-menu__item" :to="item.link">
            <i :class="['app-menu__icon', item.icon]"></i>
            <span class="app-menu__label">{{ item.label }}</span>
          </router-link>
        </template>
</li> -->
    </ul>
  </aside>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "SideBar",
  computed: {
    ...mapGetters(["currentUser"]),
  },
  data() {
    return {
      menuItems: [
        {
          label: "Pages",
          icon: "bi bi-file-earmark",
          isTreeview: true,
          isExpanded: false,
          submenu: [
            {
              label: "Blank Page",
              icon: "bi bi-circle-fill",
              link: "/blank-page",
            },
            {
              label: "Login Page",
              icon: "bi bi-circle-fill",
              link: "/auth/login",
            },
            {
              label: "Lockscreen Page",
              icon: "bi bi-circle-fill",
              link: "/lockscreen",
            },
            {
              label: "User Profile Page",
              icon: "bi bi-circle-fill",
              link: "/profile",
            }, // Changed to /profile
            {
              label: "Invoice Page",
              icon: "bi bi-circle-fill",
              link: "/invoice",
            },
            { label: "Mailbox", icon: "bi bi-circle-fill", link: "/mailbox" },
            { label: "Error Page", icon: "bi bi-circle-fill", link: "/error" },
          ],
        },
        {
          label: "Docs",
          icon: "bi bi-code-square",
          link: "/docs",
          isTreeview: false,
        },
      ],
    };
  },
  methods: {
    toggleTreeview(clickedIndex) {
      this.menuItems.forEach((item, index) => {
        if (item.isTreeview) {
          if (index === clickedIndex) {
            item.isExpanded = !item.isExpanded;
          } else {
            item.isExpanded = false;
          }
        }
      });
    },
  },
};
</script>

<style scoped>
/* Scoped styles */
.app-sidebar__user {
  display: block;
  margin-bottom: 0px;
}
</style>
